import { TAB_KEYS_BY_PAGE } from "@/const/tab.constants"
import { RESOURCES } from "@/organisms/Form"
import { useScope } from "@/pages/SettingsPage/application/scopes/useScopes"

export const getInitialValues = (
  scope: ReturnType<typeof useScope>["data"]
) => {
  const specificResourceFieldName = RESOURCES.SPECIFIC
  const initialValue = [RESOURCES.INITIAL_VALUE]

  if (!scope)
    return {
      id: undefined,
      [specificResourceFieldName]: initialValue
    }

  const { name, description, conditions, ...rest } = scope

  return {
    name_details: name,
    description_details: description,
    resources: scope.isAllResources ? RESOURCES.ALL : RESOURCES.SPECIFIC,
    [specificResourceFieldName]: scope.isAllResources
      ? initialValue
      : conditions,
    preview: {
      activeKey: TAB_KEYS_BY_PAGE.INVENTORY[0],
      open: false
    },
    ...rest
  }
}
